//#region Imports
import { Component, Input, OnInit } from '@angular/core';
import { ConfirmDialogService } from '@app/member-response-portal/service/confirm-dialog.service';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NO_SYMBOLS_OR_SPACES_PATTERN, OTHER_HEALTH_INSURANCE_VALIDATIONS } from '@app/member-response-portal/model/constants';
import { SurveyOtherHealthInsuranceHelper } from '@app/member-response-portal/shared/survey-other-health-insurance-helper';
//#endregion Imports
@Component({
    selector: 'app-policy-holder-member',
    templateUrl: './policy-holder-member.component.html',
    styleUrls: ['./policy-holder-member.component.scss']
})
export class PolicyHolderMemberComponent implements OnInit {
    //#region Public Variables
    @Input() public Form! : FormGroup;
    @Input() public Index! : number;
    @Input() public PolicyHolderIndex! : number;
    @Input() public PolicyMembers! : any;

    public PolicyMemberNameMaxLength: number = OTHER_HEALTH_INSURANCE_VALIDATIONS.POLICY_MEMBER_NAME_MAX_LENGTH;
    public PolicyMemberIdentificationMaxLength: number = OTHER_HEALTH_INSURANCE_VALIDATIONS.POLICY_MEMBER_IDENTIFICATION_MAX_LENGTH;
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    public get ShowAddPolicyMemberButton(): boolean {
        return (this.Index === this.PolicyMembers.length -1) && this.PolicyMembers.valid;
    }

    public get ShowDeletePolicyMemberButton(): boolean {
        return this.Index >= 1;
    }

    public get PolicyMemberName(): FormControl {
        return this.Form.get('PolicyMemberName') as FormControl;
    }

    public get PolicyMemberDateOfBirth(): FormControl {
        return this.Form.get('PolicyMemberDateOfBirth') as FormControl;
    }

    public get PolicyMemberIdentification(): FormControl {
        return this.Form.get('PolicyMemberIdentification') as FormControl;
    }

    //#endregion Properties

    //#region Constructor
    constructor(
        private confirmDialogService: ConfirmDialogService) { }

        public ngOnInit(): void {

            const controlsToValidate: string[] = ['PolicyMemberName', 'PolicyMemberIdentification'];
            const validators: ValidatorFn = Validators.pattern(NO_SYMBOLS_OR_SPACES_PATTERN);

            controlsToValidate.forEach((control : string) => {
                this.Form.get(control).addValidators(validators);
            });
        }
        //#endregion Constructor

        //#region Public Methods
        public AddPolicyHolderMember() : void{
            this.PolicyMembers.push(SurveyOtherHealthInsuranceHelper.CreatePolicyHolderMemberFormGroup());
        }

        public DeletePolicyHolderMember() : void{
            if(!this.IsDirtyPolicyMemberSectionForm()){
                this.PolicyMembers.removeAt(this.Index);
            }else{
                const onConfirmOption =  (): void => {
                    this.PolicyMembers.removeAt(this.Index);
                };
                const onCancelOption = (): void => {
                    //No action needed
                };

                this.confirmDialogService.OpenDialogDeleteConfirmation(
                    onConfirmOption,
                    onCancelOption
                );
            }
        }

        public SetErrorTooltipMessage(value: string, message: string) : string {
            if (this.Form.get(value).hasError('pattern')) {
                return `Invalid ${message}`;
            }

            return null;
        }

        private IsDirtyPolicyMemberSectionForm() : boolean {
            return this.PolicyMemberName.value ||
            this.PolicyMemberDateOfBirth.value ||
            this.PolicyMemberIdentification.value
        }
        //#endregion Public Methods
    }
